import React, { FC } from 'react';

import s from './Placeholder.module.scss';

export type PlaceholderProps = {
  className?: string;
};

const Placeholder: FC<PlaceholderProps> = () => {
  return <div data-testid="defaultPlaceholder" className={s.placeholder} />;
};

export default Placeholder;
